import { Component, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { GlobalServices } from 'src/app/shared/services/global.service';
import { TranslateService } from '@ngx-translate/core';
import { ActivatedRoute, Router } from '@angular/router';
import { AuthenticationService } from 'src/app/front-user/shared/services/authentication.service';
import { AlertService } from 'src/app/shared/components/alert/alert.service';
import { BaseRequestService } from 'src/app/front-user/shipyard-service/services/base-request.service';
import { FormMode, Languages, ServiceStatus, RefundMeasFirstReviewerDecision, TransitType ,TransitRequestWFSteps} from 'src/app/shared/models/enums.model';
import { first } from 'rxjs/operators';
import { BaseRequest } from 'src/app/shared/models/base-request.model';
import { User } from 'src/app/front-user/shared/models/user.model';
import { TransitRequestCustomDTO } from 'src/app/shared/models/transit-request-custom-dto.model';
import { ResponseObject } from 'src/app/shared/models/response-object.model';
import { TransitAdminService } from '../../shared/services/transit-admin.service';
import { CustomValidators } from 'src/app/front-user/shipyard-service/models/custom-validator';
import { TransitAdminDto } from '../../shared/models/transit-admin.model';
import { TransitRequestComponent } from 'src/app/front-user/services/e-booking/transit-request/transit-request.component';
import { TransitService } from 'src/app/front-user/services/e-booking/transit-request/transit-request.service';
import { FeesEstimate } from 'src/app/front-user/services/e-booking/fees-estimation-request/fees-estimate.model';
import { TransitRequestDto } from 'src/app/front-user/services/e-booking/transit-request/transit-request.model';
import { WFHistoryService } from 'src/app/shared/services/wfhistory.service';



@Component({
  selector: 'app-marine-officer-confirmation',
  templateUrl: './marine-officer-confirmation.component.html',
  styleUrls: ['./marine-officer-confirmation.component.css']
})
export class MarineOfficerconfirmationComponent implements OnInit {

  @ViewChild('transitRequest', { static: false }) transitRequest: TransitRequestComponent;
  displayedLang: string;
  submitted = false;
  baseRequestId: string = '';
  FeesEstimateObj: FeesEstimate = new FeesEstimate();

  user: User = new User();
  decisionValue: number;
  stepHistoryId: any;
  stepId: number = TransitRequestWFSteps.ConfirmVesselArrived;
  now;
  showRequest: boolean = false;
  isArrived: boolean = false;
  TransitDate: Date;
  TransitType: number;
  Direction: number;
  isErrorMessage: boolean = false;
  lockTaskErrorMessage: boolean = false;
  stepData: any;
  RequestApprovedLimitRate:string;
  transitData: TransitRequestDto = new TransitRequestDto();
  transitRequestCustomObj: TransitRequestCustomDTO = new TransitRequestCustomDTO();
  @ViewChild('TransitRequest', { static: false }) TransitRequest: TransitRequestComponent;
  requestStatus: number;
  loading = false;
  public FormMode: any = FormMode;
  public formMode: any = FormMode.Add;
  baseRequestDTO: BaseRequest;

  decision = RefundMeasFirstReviewerDecision;
  decisionKeys = Object.keys(this.decision);
  adminDecisionObject: TransitAdminDto = new TransitAdminDto();
  marineOfficeConfirmationForm: FormGroup;
  responseObj: ResponseObject = new ResponseObject();
  requestStatuses: any;
  constructor(private formBuilder: FormBuilder, private baseRequestService: BaseRequestService,
    private globalSrv: GlobalServices,
    private transitService: TransitService,
    private wfhistoryService: WFHistoryService,
    private route: ActivatedRoute, private router: Router,
    private translate: TranslateService, private adminSrv: TransitAdminService,
    private authenticationService: AuthenticationService, private alertService: AlertService) {
    this.decisionKeys = this.decisionKeys.slice(this.decisionKeys.length / 2);
    this.displayedLang = this.globalSrv.getLanguage() == Languages.Arabic ? 'NameAR' : 'NameEN';
    if (history.state.data && history.state.data.requestId) {
      this.baseRequestId = history.state.data.requestId;
      this.stepHistoryId = history.state.data.stepHistoryId;
      this.getBaseRequest();
    }
    else {
      window.history.back();
    }
    this.getBaseRequest();
    this.user = this.globalSrv.user;
    //this.baseRequestId = '7ba0a817-197c-430a-a4e9-000021631184';

  }
  ngOnInit() {
    //let x = this.transitRequest.transitRequestEle.nativeElement;
    this.now = new Date();
    this.buildForm();
    if( this.formMode != FormMode.Readonly){
    this.marineOfficeConfirmationForm.get('ETATime')?.valueChanges.subscribe(val => {
      if (val instanceof Date) {
        this.onTimeChanged(val);
      }
    });
    this.marineOfficeConfirmationForm.get('ETA')?.valueChanges.subscribe(val => {
      if( this.formMode != FormMode.Readonly){
      this.marineOfficeConfirmationForm.get('ETATime')?.reset();
      this.marineOfficeConfirmationForm.patchValue({
        TimeRate: 0,
      });
    }
    });
  }

  }


  formatDate_DDMMYYYY(date: Date): Date {


    return new Date(date.getFullYear(), date.getMonth(), date.getDate());
  }
  onTimeChanged(date: Date) {
    const hours = date.getHours();
    const minutes = date.getMinutes();
    if( this.formMode != FormMode.Readonly){
    this.AfterLimitTimeRate(minutes, hours)
    }
  }

  AfterLimitTimeRate(minutes: Number, hours: number) {

    let x = this.marineOfficeConfirmationForm.controls['ETA'].value;
    let ArrivalDay = this.formatDate_DDMMYYYY(x);
    let transitDate = this.formatDate_DDMMYYYY(this.TransitDate);
    if (this.Direction == 3) {
      if (this.TransitType == TransitType.DIRECTTRANSIT) {
        if (this.isSameDay(ArrivalDay, transitDate)) {

          if (hours == 0 && minutes == 0) {
            this.marineOfficeConfirmationForm.patchValue({
              TimeRate: 5,
            });
          }
         else if (hours == 0 && minutes != 0) {
            this.marineOfficeConfirmationForm.patchValue({
              TimeRate: 10,
            });
          }
         else if (hours == 1 && minutes == 0) {
            this.marineOfficeConfirmationForm.patchValue({
              TimeRate: 10,
            });
          }
          else if (hours == 1 && minutes != 0) {
            this.marineOfficeConfirmationForm.patchValue({
              TimeRate: 12,
            });
          }
          else{
            this.marineOfficeConfirmationForm.patchValue({
              TimeRate: 12,
            });
          }
        }
        else if (this.isPreviousDay(ArrivalDay, transitDate)) {
          if (hours == 23 && minutes == 0) {
            this.marineOfficeConfirmationForm.patchValue({
              TimeRate: 0,
            });
          }
         else if (hours == 23 && minutes != 0) {
            this.marineOfficeConfirmationForm.patchValue({
              TimeRate: 5,
            });
          }
          else {
            this.marineOfficeConfirmationForm.patchValue({
              TimeRate: 0,
            });
          }
        }
        else {
          this.marineOfficeConfirmationForm.patchValue({
            TimeRate: 0,
          });
        }
      }
      else if (this.TransitType == TransitType.LOADINGUNLOADING) {
        this.marineOfficeConfirmationForm.patchValue({
          TimeRate: 0,
        });
      }
      else if (this.TransitType == TransitType.FROMDAMIETTA) {
        if (this.isSameDay(ArrivalDay, transitDate)) {
          if (hours == 0) {
            this.marineOfficeConfirmationForm.patchValue({
              TimeRate: 0,
            });
          }
          else if (hours == 1 && minutes == 0) {
            this.marineOfficeConfirmationForm.patchValue({
              TimeRate: 0,
            });
          }
          else if (hours == 1 && minutes != 0) {
            this.marineOfficeConfirmationForm.patchValue({
              TimeRate: 12,
            });
          }
          else if (hours > 1) {
            this.marineOfficeConfirmationForm.patchValue({
              TimeRate: 12,
            });
          }
        }
        else if (this.isPreviousDay(ArrivalDay, transitDate)) {
          if (hours == 23 && minutes == 0) {
            this.marineOfficeConfirmationForm.patchValue({
              TimeRate: 0,
            });
          }
          else if (hours == 23 && minutes != 0) {
            this.marineOfficeConfirmationForm.patchValue({
              TimeRate: 0,
            });
          }
          else {
            this.marineOfficeConfirmationForm.patchValue({
              TimeRate: 0,
            });
          }
        }
        else {
          this.marineOfficeConfirmationForm.patchValue({
            TimeRate: 0,
          });
        }
      }
    }
    else if (this.Direction = 2) {
      if (this.isSameDay(ArrivalDay, transitDate)) {

        if (hours == 0 && minutes == 0) {
          this.marineOfficeConfirmationForm.patchValue({
            TimeRate: 5,
          });
        }
        else if (hours == 0 && minutes != 0) {
          this.marineOfficeConfirmationForm.patchValue({
            TimeRate: 10,
          });
        }
       else if (hours == 1 && minutes == 0) {
          this.marineOfficeConfirmationForm.patchValue({
            TimeRate: 10,
          });
        }
        else if (hours == 1 && minutes != 0) {
          this.marineOfficeConfirmationForm.patchValue({
            TimeRate: 12,
          });
        }
        else{
        this.marineOfficeConfirmationForm.patchValue({
          TimeRate: 12,
        });
      }
      }
      else if (this.isPreviousDay(ArrivalDay, transitDate)) {
        if (hours == 23 && minutes == 0) {
          this.marineOfficeConfirmationForm.patchValue({
            TimeRate: 0,
          });
        }
        else if (hours == 23 && minutes != 0) {
          this.marineOfficeConfirmationForm.patchValue({
            TimeRate: 5,
          });
        }
        else {
          this.marineOfficeConfirmationForm.patchValue({
            TimeRate: 0,
          });
        }
      }
      else {
        this.marineOfficeConfirmationForm.patchValue({
          TimeRate: 0,
        });
      }
    }
    else {
      this.marineOfficeConfirmationForm.patchValue({
        TimeRate: 0,
      });
    }
  }
  buildForm() {
    this.marineOfficeConfirmationForm = this.formBuilder.group({

      // ETA: ['', [Validators.required, CustomValidators.dateValidator()]],
      ETA: [this.now, [Validators.required]],
      ETATime: [this.now, [Validators.required]],
      TimeRate: ['', [Validators.required, Validators.pattern(/^[0-9]+$/)]],
      Arrived: [false, [Validators.requiredTrue]],

    });
    this.marineOfficeConfirmationForm.controls['ETATime'].enable();
    this.marineOfficeConfirmationForm.get('ETATime').enable();
    this.marineOfficeConfirmationForm.controls.ETATime.updateValueAndValidity();
  }
  onArrivedChange(event: Event) {
    const checked = (event.target as HTMLInputElement).checked;

    if (checked) {
    this.isArrived = true;
    this.AfterLimitTimeRate(this.now.getMinutes(),this.now.getHours());
    this.marineOfficeConfirmationForm.controls['ETATime'].enable();
    this.marineOfficeConfirmationForm.get('ETATime').enable();
    this.marineOfficeConfirmationForm.controls.ETATime.updateValueAndValidity();

    }
    else {
      this.isArrived = false;
    }
  }

  getBaseRequest() {
    this.baseRequestService.getBaseRequest(this.baseRequestId).subscribe(
      d => {
        this.baseRequestDTO = d.Data;
        // this.requestStatus = this.baseRequestDTO.StatusId;
        this.requestStatuses = this.baseRequestDTO.RequestStatuses.map(s => s.StatusId);
        this.getTransitRequest();
        if (this.requestStatuses.includes(ServiceStatus.Transit_PendingConfirmVesselArrivel)) {
          this.formMode = FormMode.Add;
        }
        else if (history.state.data && history.state.data.isCompleted && history.state.data.StepId == this.stepId) {

          this.formMode = FormMode.Readonly;
          this.getTransitRequestWFHistoryById();

        }
        else {

          this.formMode = FormMode.Readonly;
          this.getTransitRequestWFHistory();
        }

      }
    )
  }
  

  getTransitRequestWFHistoryById() {
    this.wfhistoryService.getByRequestIdByStepIdById(this.baseRequestId, TransitRequestWFSteps.ConfirmVesselArrived, this.stepHistoryId).pipe(first()).subscribe(
      (resObj: ResponseObject) => {
        this.responseObj = resObj;
        this.stepData = this.responseObj.Data["StepData"] ? JSON.parse(this.responseObj.Data["StepData"]) : null;
        this.getTransitRequestWFHistoryCompleted(this.stepData);
      }
    );
  }
  getTransitRequestWFHistory() {
    this.wfhistoryService.getByRequestIdByStepId(this.baseRequestId, TransitRequestWFSteps.ConfirmVesselArrived).subscribe(
      (resObj: ResponseObject) => {
        this.responseObj = resObj;
        if (this.responseObj.Success) {
          this.stepData = this.responseObj.Data["StepData"] ? JSON.parse(this.responseObj.Data["StepData"]) : null;
          this.getTransitRequestWFHistoryCompleted(this.stepData);
        }
      }

    );
  }
  getTransitRequestWFHistoryCompleted(stepData: any) {
    if (!stepData) return;
    this.isArrived = this.stepData.Arrived;
    this.marineOfficeConfirmationForm.patchValue({
      Arrived: this.isArrived
    });
    if(this.isArrived){
    this.marineOfficeConfirmationForm.patchValue({
      TimeRate: this.stepData.TimeRate,
      ETATime:this.stepData.ETATime?.slice(0, 16),
      ETA:this.stepData.ETA

    });
    }
  }
  onSubmit() {
    this.submitted = true;
    if (this.marineOfficeConfirmationForm.invalid) {
      return;
    }

    this.alertService.clear();
    this.globalSrv.isLoaderEnabled = true;
    this.loading = true;
    this.transitRequestCustomObj.RequestId = this.baseRequestId;
    this.transitRequestCustomObj.RequestApprovedLimitRate = this.RequestApprovedLimitRate;
    this.transitRequestCustomObj.LimitTimeRate = this.marineOfficeConfirmationForm.controls['TimeRate'].value
    this.transitRequestCustomObj.StepData = JSON.stringify(this.marineOfficeConfirmationForm.getRawValue());
    this.transitRequestCustomObj.CompletedBy = this.user.UserName;
    this.transitRequestCustomObj.ComponentURL = this.router ? this.router.url.split('/')[1] + '/' + this.router.url.split('/')[2] : '';
    
    this.transitRequestCustomObj.IsAdmin = this.user.IsAdmin;
    this.transitRequestCustomObj.DirectionId = this.TransitRequest.feesRequest.feesDetailsForm.get('DirectionId')?.value;


    this.transitService.SubmitMarineOfficerConfirmationDecision(this.transitRequestCustomObj)
      .subscribe(
        (data: ResponseObject) => {
          if (data.Success) {
            this.globalSrv.isLoaderEnabled = false;
            this.loading = false;
            this.showRequest = true;
            this.isErrorMessage = false;
          }
          else if (data.ErrorMessages.find(e => e == "TaskCompletedByAnotherUser") != null) {
            this.lockTaskErrorMessage = true;
            this.showRequest = true;
            this.globalSrv.isLoaderEnabled = false;
          }
          else {
            this.globalSrv.isLoaderEnabled = false;
            this.showRequest = true;
            this.isErrorMessage = true;
            this.loading = false;
          }
        });
  }
  get form() {
    return this.marineOfficeConfirmationForm.controls;
  }
  receiveFeesValue($event) {
    this.FeesEstimateObj = $event;
    if (this.baseRequestId && this.FeesEstimateObj) {

      this.Direction = this.FeesEstimateObj.DirectionId;

    }
  }

  isSameDay(date1: Date, date2: Date): boolean {
    return (
      date1.getFullYear() === date2.getFullYear() &&
      date1.getMonth() === date2.getMonth() &&
      date1.getDate() === date2.getDate()
    );
  }
  isPreviousDay(dateToCheck: Date, referenceDate: Date): boolean {
    const d1 = new Date(dateToCheck);
    const d2 = new Date(referenceDate);

    // Normalize both dates to midnight
    d1.setHours(0, 0, 0, 0);
    d2.setHours(0, 0, 0, 0);

    // Subtract one day from reference date
    const previousDay = new Date(d2);
    previousDay.setDate(previousDay.getDate() - 1);

    return d1.getTime() === previousDay.getTime();
  }
  public getTransitRequest() {
    this.transitService.get(this.baseRequestId).pipe(first()).subscribe(
      (resObj: ResponseObject) => {

        this.responseObj = resObj;
        if (this.responseObj.Success) {
          this.transitData = resObj.Data;
          this.TransitDate = new Date(this.transitData.AgentTransitDate);
          this.TransitType = this.transitData.TransitType;
          this.RequestApprovedLimitRate = this.transitData.ExtraFee;
        }
      });
  }
}
